// Vendor
import { ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
import Highcharts from './highcharts';
// Utils & Constants
import { FIGURE, getBasicFormatted } from 'NewAngular/utils/number_formatter';
import { FULL_WIDTH, HIGHCHARTS_HEATMAP_DEFAULT_OPTIONS, MIN_SQUARE_SIZE, NO_DATA_HEIGHT } from './constants';
// Services
import { PortfolioOptimizerService } from 'PortfolioOptimizerApp/services/portfolio-optimizer.service';
import { OptimizerErrorCode } from 'PortfolioOptimizerApp/enums/portfolio-optimizer.enum';
import * as i0 from "@angular/core";
import * as i1 from "PortfolioOptimizerApp/services/portfolio-optimizer.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
function CorrelationMatrixHeatmapComponent_ycn_loading_symbol_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 5);
} }
function CorrelationMatrixHeatmapComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "div", 8)(3, "div", 9)(4, "span", 10);
    i0.ɵɵtext(5, "Strong Negative");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 11);
    i0.ɵɵtext(7, "-1.00 to -0.70");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 8)(9, "div", 12)(10, "span", 10);
    i0.ɵɵtext(11, "Moderate Negative");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 11);
    i0.ɵɵtext(13, "-0.69 to -0.30");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 8)(15, "div", 13)(16, "span", 10);
    i0.ɵɵtext(17, "Weak/None");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "span", 11);
    i0.ɵɵtext(19, "-0.29 to 0.19");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 8)(21, "div", 14)(22, "span", 10);
    i0.ɵɵtext(23, "Moderate Positive");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "span", 11);
    i0.ɵɵtext(25, "0.20 to 0.69");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 8)(27, "div", 15)(28, "span", 10);
    i0.ɵɵtext(29, "Strong Positive");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(30, "span", 11);
    i0.ɵɵtext(31, "0.70 to 1.00");
    i0.ɵɵelementEnd()()()();
} }
function CorrelationMatrixHeatmapComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵelement(2, "div", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("width", ctx_r0.width)("height", ctx_r0.height);
    i0.ɵɵproperty("id", ctx_r0.chartElemId);
} }
export class CorrelationMatrixHeatmapComponent {
    constructor(portfolioOptimizerService, elementRef) {
        this.portfolioOptimizerService = portfolioOptimizerService;
        this.elementRef = elementRef;
        this.chartDataUrl = '';
        this.chartOptions = {};
        this.withCorrelationPoints = false;
        this.errorHandler = new EventEmitter(true);
        this.hasData = new EventEmitter(true);
        this.chartElemId = 'correlationMatrixHeatmapChart';
        this.width = FULL_WIDTH;
        this.height = `${NO_DATA_HEIGHT}px`;
        this.isLoading = false;
        this.chartMinSize = 0;
    }
    ngOnChanges(changes) {
        if (changes.chartDataUrl?.currentValue) {
            this.highchartOptions = Highcharts.merge(HIGHCHARTS_HEATMAP_DEFAULT_OPTIONS, this.chartOptions);
            this.getChartData(this.chartDataUrl);
        }
    }
    calculateContainerWidth() {
        this.calculateChartSize();
    }
    getChartData(chartDataUrl) {
        this.isLoading = true;
        this.hasData.emit(false);
        this.portfolioOptimizerService.getCorrelationMatrixDataFromUrl(chartDataUrl).subscribe({
            next: (response) => this.renderChart(response),
            error: ({ error }) => this.errorHandler.emit(error),
        });
    }
    renderChart(chartData) {
        this.isLoading = false;
        this.hasData.emit(true);
        const { series, securities: categories, securities_names } = chartData;
        if (!categories.length) {
            this.errorHandler.emit({ code: OptimizerErrorCode.NoData });
            return;
        }
        this.chartMinSize = categories.length * MIN_SQUARE_SIZE + 45;
        this.calculateChartSize();
        const data = series.map((point) => ({
            ...point,
            xSecurity: securities_names ? securities_names[point.x ?? 0] : categories[point.x ?? 0],
            ySecurity: securities_names ? securities_names[point.y ?? 0] : categories[point.y ?? 0],
            valueFormatted: getBasicFormatted(point.value ?? 0, FIGURE, 4).replace(/(0\.)/g, '.'),
        }));
        this.highchartOptions.series[0].data = data;
        // eslint-disable-next-line no-nested-ternary
        const fontSize = categories.length < 30 ? '12px' : categories.length < 50 ? '8px' : '5px';
        this.highchartOptions.series[0].dataLabels = {
            enabled: this.withCorrelationPoints,
            style: { fontSize, fontWeight: 'normal', textOutline: 'none' },
        };
        this.highchartOptions = Highcharts.merge(this.highchartOptions, {
            xAxis: {
                categories,
            },
            yAxis: {
                categories,
            },
            tooltip: {
                headerFormat: '',
                followPointer: true,
                formatter() {
                    const securityStlye = 'width:max-content;max-width:13ch;white-space:break-spaces;';
                    const { xSecurity, ySecurity, valueFormatted } = this.point;
                    return this.point.value
                        ? `
                    <div class='tippy-box popover bg-semi-transparent'><div class='tippy-content'>
                        <div class='mb-1' style='display:flex;justify-content:space-between;'>
                            <div class='text-bold' style='${securityStlye}margin: 0 20px 0 0;'>${xSecurity}</div>
                            <div class='text-bold' style='${securityStlye}'>${ySecurity}</div>
                        </div>
                        <div>
                            <span class="text-thin text-uppercase">Correlation:</span> 
                            <span class='text-bold'>${valueFormatted}</span>
                        </div>
                    </div></div>`
                        : false;
                },
                useHTML: true,
                style: {
                    fontSize: 'inherit',
                },
            },
        });
        const observer = new MutationObserver((_mutations) => {
            if (document.getElementById(this.chartElemId)) {
                observer.disconnect();
                Highcharts.chart(this.chartElemId, this.highchartOptions);
            }
        });
        observer.observe(this.elementRef.nativeElement, { childList: true, subtree: true });
    }
    calculateChartSize() {
        const containerWidth = window.innerWidth - 135; // correlation right bar
        const containerHeight = window.innerHeight;
        this.width = this.chartMinSize < containerWidth ? '100%' : `${this.chartMinSize}px`;
        this.height = this.chartMinSize < containerHeight ? '100vh' : `${this.chartMinSize}px`;
    }
}
CorrelationMatrixHeatmapComponent.ɵfac = function CorrelationMatrixHeatmapComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationMatrixHeatmapComponent)(i0.ɵɵdirectiveInject(i1.PortfolioOptimizerService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
CorrelationMatrixHeatmapComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CorrelationMatrixHeatmapComponent, selectors: [["ycn-correlation-matrix-heatmap"]], hostBindings: function CorrelationMatrixHeatmapComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("resize", function CorrelationMatrixHeatmapComponent_resize_HostBindingHandler($event) { return ctx.calculateContainerWidth($event); }, i0.ɵɵresolveWindow);
    } }, inputs: { chartDataUrl: "chartDataUrl", chartOptions: "chartOptions", withCorrelationPoints: "withCorrelationPoints" }, outputs: { errorHandler: "errorHandler", hasData: "hasData" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[1, "matrix", "flex-auto", "pb-10"], ["style", "grid-template-columns: auto", "loaderMessage", "Loading...", 4, "ngIf"], [1, "matrix-wrap", "height-full", 2, "grid-template-columns", "auto 1fr"], ["class", "matrix-legend", "style", "padding-top: 50px;", 4, "ngIf"], ["class", "d-flex flex-column overflow-auto", 4, "ngIf"], ["loaderMessage", "Loading...", 2, "grid-template-columns", "auto"], [1, "matrix-legend", 2, "padding-top", "50px"], [1, "matrix-legend-labels"], [1, "matrix-legend-item"], [1, "chart-legend-item-title", "bullet-lg", "bullet-positive-2"], [1, "text-bold", "text-uppercase"], [1, "matrix-legend-value"], [1, "chart-legend-item-title", "bullet-lg", "bullet-positive-5"], [1, "chart-legend-item-title", "bullet-lg", "bullet-neutral"], [1, "chart-legend-item-title", "bullet-lg", "bullet-negative-5"], [1, "chart-legend-item-title", "bullet-lg", "bullet-negative-2"], [1, "d-flex", "flex-column", "overflow-auto"], [1, "matrix-area", "flex-auto", 2, "overflow", "auto"], [1, "no-highcharts-darkmode-override", 3, "id"]], template: function CorrelationMatrixHeatmapComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CorrelationMatrixHeatmapComponent_ycn_loading_symbol_1_Template, 1, 0, "ycn-loading-symbol", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, CorrelationMatrixHeatmapComponent_div_3_Template, 32, 0, "div", 3)(4, CorrelationMatrixHeatmapComponent_div_4_Template, 3, 5, "div", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isLoading);
    } }, dependencies: [i2.NgIf, i3.LoadingSymbolComponent], encapsulation: 2 });
